module.exports = __webpack_public_path__ + "static/img/14000358.220244f1.png";